import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9253 1.33301V5.56941"
      stroke="currentColor"
      strokeWidth="2.26667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.6"
      d="M11.9253 18.2783V22.5147"
      stroke="currentColor"
      strokeWidth="2.26667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.9"
      d="M4.4375 4.43652L7.43476 7.43378"
      stroke="currentColor"
      strokeWidth="2.26667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M16.4141 16.415L19.4113 19.4123"
      stroke="currentColor"
      strokeWidth="2.26667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.8"
      d="M1.33325 11.9241H5.56966"
      stroke="currentColor"
      strokeWidth="2.26667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M18.2791 11.9241H22.5155"
      stroke="currentColor"
      strokeWidth="2.26667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.7"
      d="M4.4375 19.4123L7.43476 16.415"
      stroke="currentColor"
      strokeWidth="2.26667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.3"
      d="M16.4141 7.43378L19.4113 4.43652"
      stroke="currentColor"
      strokeWidth="2.26667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
